export default "__VITE_ASSET__DeMLa0Oj__"